import * as Sentry from "@sentry/react";
import { AxiosError } from "axios";

export const initSentry = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN, // 에러 로깅 서비스 주소
    integrations: [
      Sentry.browserTracingIntegration(), 
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      })
    ],
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
    // 세션 리플레이 샘플링 비율 > 전체 사용자 세션 중 0%를 무작위 녹화
    // 저사양 PC에서 백그라운드로 CPU를 계속 사용하기 때문에 성능 이슈가 발생할 수도 있음
    replaysSessionSampleRate: 0,
    // 에러 발생 시 리플레이 샘플링 비율 > 에러 발생 사용자 세션 100% 녹화
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV,
    release: `okgo@${process.env.REACT_APP_VERSION ?? ""}`,
    enabled: process.env.REACT_APP_ENV === "production",
    ignoreErrors: ["Uncaught ReferenceError: fn_web_view_check is not defined"],
  });
};
